import { z } from "zod";
/**
 * The rating prompt and the short satisfaction check (`D251`): what a
 * workout's summary may ask, and what one tap on either sends.
 *
 * ── THE PROMPT TRAVELS AS A STRING ──────────────────────────────────────────
 * `prompt` is `"rating"`, `"csat"` or `null` today, but the wire carries a
 * plain string: a third question added later must decode in every installed
 * app, which draws only the prompts it has copy for (`D172`, as `D204`'s
 * achievements do).
 */
/** The two questions, in the order a summary prefers them. */
export const APP_FEEDBACK_PROMPTS = ["rating", "csat"];
/** Sim · Mais ou menos · Não. The CHECK on `app_feedback.answer` (`0042`). */
export const RATING_ANSWERS = ["yes", "unsure", "no"];
export const ratingAnswer = z.enum(RATING_ANSWERS);
/** The comment's ceiling, in characters, after trimming. */
export const APP_FEEDBACK_COMMENT_MAX = 1000;
/** `GET /me/feedback/prompt?sessionId=` */
export const feedbackPromptQuery = z.strictObject({
    sessionId: z.string().min(1),
});
export const feedbackPromptOutput = z.object({
    /** `"rating"`, `"csat"`, or `null` for nothing to ask. */
    prompt: z.string().min(1).nullable(),
    /** The session's workout number, or `null` when it is not a workout. */
    workoutNumber: z.int().positive().nullable(),
});
const comment = z.string().trim().max(APP_FEEDBACK_COMMENT_MAX).optional();
/**
 * `POST /me/feedback` — one tap. Three shapes, each strict (`D172`):
 *
 * - a rating's answer, with an optional comment;
 * - a satisfaction score (1–5), with an optional comment;
 * - a dismissal ("Agora não") of either, carrying nothing else.
 *
 * `id` is the client's UUIDv7, minted when the prompt is drawn, so a resend
 * is the same row (`D163`) — never `crypto.randomUUID()` (`T-174`).
 */
export const appFeedbackInput = z.union([
    z.strictObject({
        answer: ratingAnswer,
        comment,
        id: z.uuid(),
        kind: z.literal("rating"),
        sessionId: z.string().min(1),
    }),
    z.strictObject({
        comment,
        id: z.uuid(),
        kind: z.literal("csat"),
        score: z.int().min(1).max(5),
        sessionId: z.string().min(1),
    }),
    z.strictObject({
        dismissed: z.literal(true),
        id: z.uuid(),
        kind: z.enum(APP_FEEDBACK_PROMPTS),
        sessionId: z.string().min(1),
    }),
]);
/** The stored row's answer — on a replay, the first attempt's moment. */
export const appFeedbackOutput = z.object({
    id: z.uuid(),
    recordedAt: z.iso.datetime(),
});
//# sourceMappingURL=app-feedback.js.map